import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'video-type',
  templateUrl: './video-type.component.html',
  styleUrls: ['./video-type.component.css']
})
export class VideoTypeComponent implements OnInit {

  @Input() question_index: number;
  @Input() question_name: string;
  @Input() question_name_second: string;
  @Input() is_mandt: boolean;
  @Input() userRes : string[];
  @Input() question_number: number;
  @Output() user_Resp = new EventEmitter<string[]>();
  @Input() indexOfRepeater: number;

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/questions-type/video-type/video-type.component.ts